import React, { SVGProps } from 'react';

const AnnouncementIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="AnnouncementIcon">
    <path
      d="M.833 18.333a6.667 6.667 0 1 1 13.334 0H12.5a5 5 0 0 0-10 0H.833Zm6.667-7.5c-2.763 0-5-2.237-5-5 0-2.762 2.237-5 5-5 2.762 0 5 2.238 5 5 0 2.763-2.238 5-5 5Zm0-1.666a3.332 3.332 0 1 0 0-6.667 3.332 3.332 0 1 0 0 6.667ZM17.957.653a11.618 11.618 0 0 1 1.21 5.18c0 1.861-.436 3.62-1.21 5.18l-1.371-.996a9.963 9.963 0 0 0 .914-4.184c0-1.493-.328-2.91-.914-4.183l1.37-.997Zm-2.752 2a8.31 8.31 0 0 1 .628 3.18 8.31 8.31 0 0 1-.628 3.18l-1.398-1.016c.239-.697.36-1.428.36-2.164 0-.736-.12-1.467-.359-2.163l1.397-1.017Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default AnnouncementIcon;
